/**
 * AI 对话页（占位）：AI agent + 紫微斗数知识库，功能开发中
 * 仅 App 端「AI 对话」Tab 展示；功能未开发，此处占位提示（图标用 SVG，遵循移动端禁 emoji 约定）
 */
export default function ChatPage() {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg bg-white px-4 py-20 text-center shadow">
      <svg
        width="44"
        height="44"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-slate-400"
      >
        <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-4.5A8 8 0 1 1 21 12Z" />
        <circle cx="9" cy="12" r="0.6" fill="currentColor" stroke="none" />
        <circle cx="12" cy="12" r="0.6" fill="currentColor" stroke="none" />
        <circle cx="15" cy="12" r="0.6" fill="currentColor" stroke="none" />
      </svg>
      <h2 className="text-base font-medium text-slate-800">AI 对话</h2>
      <p className="text-sm text-slate-400">
        AI agent + 紫微斗数知识库
        <br />
        功能开发中，敬请期待
      </p>
    </div>
  );
}
